// utils/auth.js
import { jwtDecode } from "jwt-decode";

export const getToken = () => sessionStorage.getItem("token");

export const isAuthenticated = () => {
    const token = getToken();
    if (!token) return false;

    try {
        const decoded = jwtDecode(token);
        const now = Math.floor(Date.now() / 1000); // current time in seconds
        return decoded.exp && decoded.exp > now;
    } catch (err) {
        return false;
    }
};

export const getCurrentUser = () => {
    const token = getToken();
    if (!token) return null;

    try {
        const decoded = jwtDecode(token);
        return decoded;
    } catch (err) {
        return null;
    }
};
